// Centralized API helper
// Switch API_BASE as needed
export const API_BASE =
  process.env.REACT_APP_API_BASE || "https://api.pks.co.in/api";

console.log("API_BASE:", process.env.REACT_APP_API_BASE);

export async function apiRequest(
  path,
  method = "GET",
  body = null,
  auth = true,
) {
  const headers = {};
  if (!(body instanceof FormData)) headers["Content-Type"] = "application/json";

  const token = localStorage.getItem("token");
  if (auth && token) headers["Authorization"] = "Bearer " + token;

  let response;
  try {
    response = await fetch(API_BASE + path, {
      method,
      headers,
      body: body
        ? body instanceof FormData
          ? body
          : JSON.stringify(body)
        : undefined,
    });
  } catch (networkErr) {
    throw new Error("Network error — check your connection");
  }

  const text = await response.text();
  let json = null;
  try {
    json = text ? JSON.parse(text) : {};
  } catch {
    if (!response.ok) throw new Error(text || "Server error");
    json = {};
  }

  if (response.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    throw new Error(json.error || "Session expired");
  }

  if (!response.ok) {
    throw new Error(json.error || json.message || "Request failed");
  }

  return json;
}

export const api = {
  get: (p, auth = true) => apiRequest(p, "GET", null, auth),
  post: (p, body, auth = true) => apiRequest(p, "POST", body, auth),
  put: (p, body, auth = true) => apiRequest(p, "PUT", body, auth),
  del: (p, auth = true) => apiRequest(p, "DELETE", null, auth),
};
